export default () => {
  if (window.self === window.top) {
    window.GhostInspectorEvents = window.GhostInspectorEvents || [];
  }
};
